import React, { useEffect, useImperativeHandle, useRef, useState } from 'react';
import { Platform } from 'react-native';
import Config from '@annunciate/core/dist/utils/config';
import { ShareButton } from './ShareButton';
import URL from '../../utils/URL';
export const ShareItemButton = React.forwardRef(({ item, ...props }, ref) => {
    const internalRef = useRef(undefined);
    const [link, setLink] = useState();
    useEffect(() => {
        if (Platform.OS !== 'web' && !Config.APP_WEB_FQDN) {
            return;
        }
        const origin = Config.APP_WEB_FQDN ? `https://${Config.APP_WEB_FQDN}` : window?.location?.origin;
        let itemLink = new URL(`${origin}/discover`);
        const path = itemLink.pathname.split('/').filter((s) => s !== '');
        if (item.__typename === 'Content') {
            path.push('item');
        }
        path.push(item.slug || item.id.toString());
        itemLink.pathname = `/${path.join('/')}`;
        setLink(itemLink.toString());
    }, [item.id, item.__typename]);
    useImperativeHandle(ref, () => {
        return { toggle: () => internalRef.current?.toggle() };
    }, [internalRef.current]);
    if (!link)
        return null;
    return (React.createElement(ShareButton, { ref: internalRef, link: link, ...props }));
});
//# sourceMappingURL=ShareItemButton.js.map